// Kooturavu.jsx
import React, { useState } from "react";

const Kooturavu = () => {
  const [showTable, setShowTable] = useState(false);

const kooturavuData = [
    { sl: 1, region: "Ariyalur", institution: "Udaiyarpalayam, PACCS", shop: "Ariyalur" },
    { sl: 2, region: "Ariyalur", institution: "Ariyalur CMS", shop: "Ariyalur" },
    { sl: 3, region: "Chengalpattu", institution: "Maduranthakam CMS", shop: "Maduranthakam" },
    { sl: 4, region: "Chengalpattu", institution: "Periyaputheri PACCS", shop: "Chengalpattu" },
    { sl: 5, region: "Chengalpattu", institution: "Singaperumal Kovil UCCS", shop: "Chengalpattu" },
    { sl: 6, region: "Chennai", institution: "TUCS CWS", shop: "Besant Nagar" },
    { sl: 7, region: "Chennai", institution: "TUCS CWS", shop: "Kondi Thoppu, George Town, Parrys." },
    { sl: 8, region: "Chennai", institution: "TUCS CWS", shop: "R.A.Puram" },
    { sl: 9, region: "Chennai", institution: "TUCS CWS", shop: "Teynampet" },
    { sl: 10, region: "Chennai", institution: "TUCS CWS", shop: "Triplicane" },
    { sl: 11, region: "Chennai", institution: "TUCS CWS", shop: "Virugambakkam" },
    { sl: 12, region: "Chennai", institution: "Park Town CWS", shop: "Anna Nagar" },
    { sl: 13, region: "Chennai", institution: "Park Town CWS", shop: "Thirumangalam" },
    { sl: 14, region: "Chennai", institution: "NOMCO CWS", shop: "Washermanpet" },
    { sl: 15, region: "Chennai", institution: "TUCS CWS", shop: "Chennai" },
    { sl: 16, region: "Chennai", institution: "TUCS CWS", shop: "Chennai" },
    { sl: 17, region: "Chennai", institution: "Parktown CWS", shop: "Chennai" },
    { sl: 18, region: "Chennai", institution: "NOMCO CWS", shop: "Chennai" },
    { sl: 19, region: "Coimbatore", institution: "Coimbatore CWS", shop: "Head office" },
    { sl: 20, region: "Coimbatore", institution: "Coimbatore CWS", shop: "Bazar Branch" },
    { sl: 21, region: "Coimbatore", institution: "Pollachi CWS", shop: "Sudamani" },
    { sl: 22, region: "Coimbatore", institution: "Pollachi CWS", shop: "New Scheme Road" },
    { sl: 23, region: "Coimbatore", institution: "Karamadai APCMS", shop: "Karamadai" },
    { sl: 24, region: "Coimbatore", institution: "Mettupalaym APCMS", shop: "Mettupalayam" },
    { sl: 25, region: "Coimbatore", institution: "Coimbatore APCMS", shop: "Coimbatore" },
    { sl: 26, region: "Coimbatore", institution: "Sulur APCMS", shop: "Sulur" },
    { sl: 27, region: "Coimbatore", institution: "Annur PCS", shop: "Annur" },
    { sl: 28, region: "Coimbatore", institution: "Veerakeralam UCCS", shop: "Coimbatore" },
    { sl: 29, region: "Coimbatore", institution: "Saravanampatti UCCS", shop: "Coimbatore" },
    { sl: 30, region: "Cuddalore", institution: "Cuddalore Saravanabhava CWS", shop: "Near Hotel woodlands, Cuddalore" },
    { sl: 31, region: "Cuddalore", institution: "Cuddalore Saravanabhava CWS", shop: "Neyveli" },
    { sl: 32, region: "Cuddalore", institution: "Cuddalore CMS", shop: "Manjakuppam, Cuddalore" },
    { sl: 33, region: "Cuddalore", institution: "Panrutti CMS", shop: "Panrutti" },
    { sl: 34, region: "Cuddalore", institution: "Chidambaram CMS", shop: "Chidambaram" },
    { sl: 35, region: "Cuddalore", institution: "Lalpettai PACCS", shop: "Cuddalore" },
    { sl: 36, region: "Cuddalore", institution: "Mangalam Pettai PACCS", shop: "Cuddalore" },
    { sl: 37, region: "Dharmapuri", institution: "Dharmapuri CWS", shop: "Dharmapuri" },
    { sl: 38, region: "Dharmapuri", institution: "Dharmapuri CWS", shop: "Palakkodu" },
    { sl: 39, region: "Dharmapuri", institution: "Dharmapuri CWS", shop: "Pennagaram" },
    { sl: 40, region: "Dharmapuri", institution: "Harur CMS", shop: "Harur" },
    { sl: 41, region: "Dharmapuri", institution: "Harur CMS", shop: "Morappur" },
    { sl: 42, region: "Dharmapuri", institution: "Dharmapuri CWS", shop: "Dharmapuri" },
    { sl: 43, region: "Dharmapuri", institution: "Dharmapuri CWS", shop: "Dharmapuri" },
    { sl: 44, region: "Dindigul", institution: "Dindigul CWS", shop: "Dindigul" },
    { sl: 45, region: "Dindigul", institution: "Palani CMS", shop: "Palani" },
    { sl: 46, region: "Dindigul", institution: "Palani CMS", shop: "Ottanchathiram" },
    { sl: 47, region: "Dindigul", institution: "Dindigul CWS", shop: "Dindigul" },
    { sl: 48, region: "Dindigul", institution: "Dindigul CWS", shop: "Dindigul" },
    { sl: 49, region: "Erode", institution: "Erode CWS", shop: "Bus Stand" },
    { sl: 50, region: "Erode", institution: "Erode CWS", shop: "Bhavani Main Road, Perundurai" },
    { sl: 51, region: "Erode", institution: "Erode CWS", shop: "Dharapuram" },
    { sl: 52, region: "Erode", institution: "Erode CWS", shop: "Gopi" },
    { sl: 53, region: "Erode", institution: "Erode CWS", shop: "Perundurai" },
    { sl: 54, region: "Erode", institution: "Erode CWS", shop: "Sathi" },
    { sl: 55, region: "Erode", institution: "Erode CWS", shop: "Mukasi Pidariyur" },
    { sl: 56, region: "Erode", institution: "Erode CWS", shop: "Sivagiri" },
    { sl: 57, region: "Erode", institution: "Erode CWS", shop: "Kodumudi" },
    { sl: 58, region: "Erode", institution: "Erode CWS", shop: "kavindapadi" },
    { sl: 59, region: "Erode", institution: "Gobi CMS", shop: "Gobichettipalayam" },
    { sl: 60, region: "Erode", institution: "Bhavani PCS", shop: "Mettur Main Road,Bhavani" },
    { sl: 61, region: "Erode", institution: "Anthiyur PCS", shop: "Anthiyur" },
    { sl: 62, region: "Erode", institution: "Chennimalai PCS", shop: "Chennimalai" },
    { sl: 63, region: "Erode", institution: "TNSTC PCS", shop: "Jeeva Marundhangadi, New Bus stand, Erode" },
    { sl: 64, region: "Erode", institution: "Perundurai R.S.PACCS", shop: "Vellodu" },
    { sl: 65, region: "Erode", institution: "Velli Tiruppur PACCS", shop: "Erode" },
    { sl: 66, region: "Erode", institution: "Panikampalayam PACCS", shop: "Erode" },
    { sl: 67, region: "Kallakurichi", institution: "Thirukovilur CMS", shop: "Thirukovilur" },
    { sl: 68, region: "Kallakurichi", institution: "Ulundurpet PACCS", shop: "Kallakurichi" },
    { sl: 69, region: "Kancheepuram", institution: "Kancheepuram CWS", shop: "Vallal Pachaiyappan Street, Kancheepuram" },
    { sl: 70, region: "Kancheepuram", institution: "Sriperumpudur CMS", shop: "Sriperumpudur" },
    { sl: 71, region: "Kancheepuram", institution: "Muthiyalpettai PACCS", shop: "Kancheepuram" },
    { sl: 72, region: "Kancheepuram", institution: "Kilambi PACCS", shop: "Kancheepuram" },
    { sl: 73, region: "Kanniyakumari", institution: "Vadasery PCS", shop: "Vadasery" },
    { sl: 74, region: "Kanniyakumari", institution: "Kalkulam Vilavangode CMS", shop: "Marthandam" },
    { sl: 75, region: "Kanniyakumari", institution: "Kalkulam PCS", shop: "Thuckalay" },
    { sl: 76, region: "Kanniyakumari", institution: "Irenipuram PACCS", shop: "Kanniyakumari" },
    { sl: 77, region: "Kanniyakumari", institution: "Mayilaadi PACCS", shop: "Kanniyakumari" },
    { sl: 78, region: "Karur", institution: "Karur CMS", shop: "Arava kurichi" },
    { sl: 79, region: "Karur", institution: "Kulithalai CMS", shop: "Kulithalai" },
    { sl: 80, region: "Karur", institution: "Karur CWS", shop: "Karur" },
    { sl: 81, region: "Karur", institution: "Karur CMS", shop: "Karur" },
    { sl: 82, region: "Krishnagiri", institution: "Krishnagiri CMS", shop: "Govt.Hospital, Krishnagiri" },
    { sl: 83, region: "Krishnagiri", institution: "Uthangarai PACCS", shop: "Uthangarai" },
    { sl: 84, region: "Krishnagiri", institution: "Hosur PACCS", shop: "Denkanikottai road, Hosur" },
    { sl: 85, region: "Krishnagiri", institution: "Krishnagiri APCMS", shop: "Krishnagiri" },
    { sl: 86, region: "Krishnagiri", institution: "Krishnagiri APCMS", shop: "Krishnagiri" },
    { sl: 87, region: "Madurai", institution: "Madurai Pandian CWS", shop: "Thirumalai Naciker Mahal opp., Madurai" },
    { sl: 88, region: "Madurai", institution: "Madurai Pandian CWS", shop: "Anna Nagar" },
    { sl: 89, region: "Madurai", institution: "Madurai Pandian CWS", shop: "American College Campus" },
    { sl: 90, region: "Madurai", institution: "Madurai Pandian CWS", shop: "Pudur" },
    { sl: 91, region: "Madurai", institution: "Madurai Pandian CWS", shop: "Thirunagar" },
    { sl: 92, region: "Madurai", institution: "Madurai Pandian CWS", shop: "Kochadai" },
    { sl: 93, region: "Madurai", institution: "Madurai CMS", shop: "Madurai" },
    { sl: 94, region: "Madurai", institution: "Melur CMS", shop: "Melur" },
    { sl: 95, region: "Madurai", institution: "Thirumangalam CMS", shop: "Thirumangalam" },
    { sl: 96, region: "Madurai", institution: "Vadipatti CMS", shop: "Vadipatti" },
    { sl: 97, region: "Madurai", institution: "Usilampatti CMS", shop: "Usilampatti" },
    { sl: 98, region: "Madurai", institution: "Peraiyur PACCS", shop: "Near Police Station, Peraiyur" },
    { sl: 99, region: "Madurai", institution: "Madura Coats PCS", shop: "Palanganatham (Madura Coats)" },
    { sl: 100, region: "Madurai", institution: "Madura Coats PCS", shop: "Ponnagaram" },
    { sl: 101, region: "Madurai", institution: "Sivaji PCS", shop: "Mahaboopalayam Kennet 70 Feet Road, Madurai" },
    { sl: 102, region: "Madurai", institution: "Chekanoorani PACCS", shop: "Madurai" },
    { sl: 103, region: "Madurai", institution: "Othakadai UCCS", shop: "Madurai" },
    { sl: 104, region: "Mayiladuthurai", institution: "Mayiladuthurai CWS", shop: "Narayanan Pillai St., Mayiladuthurai" },
    { sl: 105, region: "Mayiladuthurai", institution: "Mayiladuthurai CWS", shop: "Kuthalam" },
    { sl: 106, region: "Mayiladuthurai", institution: "Mayiladuthurai CWS", shop: "Sirkali" },
    { sl: 107, region: "Mayiladuthurai", institution: "Mayiladuthurai CWS", shop: "Semmanar Kovil" },
    { sl: 108, region: "Mayiladuthurai", institution: "Kaveripumpattinam PACCS", shop: "Mayiladuthurai" },
    { sl: 109, region: "Mayiladuthurai", institution: "Mannampanthal PACCS", shop: "Mayiladuthurai" },
    { sl: 110, region: "Nagapattinam", institution: "Vedaranyam CMS", shop: "Jublee Bazar, Vedaranyam" },
    { sl: 111, region: "Nagapattinam", institution: "Nagapattinam CWS", shop: "Nagapattinam" },
    { sl: 112, region: "Nagapattinam", institution: "Sikkal PACCS", shop: "Nagapattinam" },
    { sl: 113, region: "Nagapattinam", institution: "Katharipulam PACCS", shop: "Nagapattinam" },
    { sl: 114, region: "Namakkal", institution: "Namakkal CWS", shop: "Mohanoor" },
    { sl: 115, region: "Namakkal", institution: "Namakkal CWS", shop: "Paramathivelur" },
    { sl: 116, region: "Namakkal", institution: "Rasipuram CMS", shop: "Rasipuram" },
    { sl: 117, region: "Namakkal", institution: "Thiruchencode CMS", shop: "Konganapuram" },
    { sl: 118, region: "Namakkal", institution: "Thiruchencode CMS", shop: "Kumarapalayam" },
    { sl: 119, region: "Namakkal", institution: "Namakkal CMS", shop: "Thiruchengode Road, Namakkal" },
    { sl: 120, region: "Namakkal", institution: "Pallipalayam FSCS", shop: "Veppadai" },
    { sl: 121, region: "Namakkal", institution: "Valayapatti PACCS", shop: "Namakkal" },
    { sl: 122, region: "Namakkal", institution: "Pothanur PACCS", shop: "Namakkal" },
    { sl: 123, region: "Nilgiris", institution: "Nilgiri Entr. CWS", shop: "Head office, Ooty" },
    { sl: 124, region: "Nilgiris", institution: "Kothagiri PCS", shop: "Kothagiri" },
    { sl: 125, region: "Nilgiris", institution: "Nilgiri CMS", shop: "Nilgiris" },
    { sl: 126, region: "Nilgiris", institution: "Aravenu PACCS", shop: "Aravenu" },
    { sl: 127, region: "Perambalur", institution: "Perambalur APCMS", shop: "Perambalur" },
    { sl: 128, region: "Perambalur", institution: "Perambalur CWS", shop: "Perambalur" },
    { sl: 129, region: "Pudukkottai", institution: "Thirumayam CMS", shop: "Thirumayam" },
    { sl: 130, region: "Pudukkottai", institution: "Aranthangi CMS", shop: "Aranthangi" },
    { sl: 131, region: "Pudukkottai", institution: "Alangudi CMS", shop: "Alangudi" },
    { sl: 132, region: "Pudukkottai", institution: "Aranthangi CMS", shop: "Pudukkottai" },
    { sl: 133, region: "Pudukkottai", institution: "Pudukkottai CWS", shop: "Pudukkottai" },
    { sl: 134, region: "Ramanathapuram", institution: "Ramanathapuram CWS", shop: "Paramakudi" },
    { sl: 135, region: "Ramanathapuram", institution: "Ramanathapuram CWS", shop: "Sayalkudi" },
    { sl: 136, region: "Ramanathapuram", institution: "Kamudhi CMS", shop: "Kamudhi" },
    { sl: 137, region: "Ramanathapuram", institution: "Paramakudi APCMS", shop: "Ramanathapuram" },
    { sl: 138, region: "Ramanathapuram", institution: "Tiruvadanai APCMS", shop: "Ramanathapuram" },
    { sl: 139, region: "Ranipet", institution: "Vellore CWS", shop: "Kaveripakkam" },
    { sl: 140, region: "Ranipet", institution: "Vellore CWS", shop: "Melvisharam" },
    { sl: 141, region: "Ranipet", institution: "T.K.Thangal UCCS", shop: "Ranipet" },
    { sl: 142, region: "Ranipet", institution: "Lalapet UCCS", shop: "Ranipet" },
    { sl: 143, region: "Salem", institution: "Salem CWS (Ponni)", shop: "Old Bus stand" },
    { sl: 144, region: "Salem", institution: "Salem CWS (Ponni)", shop: "2nd Agragaram" },
    { sl: 145, region: "Salem", institution: "Salem CWS (Ponni)", shop: "Old Bus Stand, Attur" },
    { sl: 146, region: "Salem", institution: "Salem CWS (Ponni)", shop: "Ammapet" },
    { sl: 147, region: "Salem", institution: "Salem CWS (Ponni)", shop: "Edapadi" },
    { sl: 148, region: "Salem", institution: "Salem CMS", shop: "Omalur" },
    { sl: 149, region: "Salem", institution: "Salem CMS", shop: "Gugai" },
    { sl: 150, region: "Salem", institution: "Attur CMS", shop: "(Aapcms H.O Building) Attur" },
    { sl: 151, region: "Salem", institution: "Swarnapuri PCS", shop: "Swarnapuri" },
    { sl: 152, region: "Salem", institution: "Salem CWS (Ponni)", shop: "Sankakri" },
    { sl: 153, region: "Salem", institution: "Swarnapuri PCS", shop: "Thiruvakaundanur" },
    { sl: 154, region: "Salem", institution: "Salem CWS (Ponni)", shop: "Nangavalli" },
    { sl: 155, region: "Salem", institution: "Salem APCMS", shop: "Salem" },
    { sl: 156, region: "Salem", institution: "Salem CWS (Ponni)", shop: "Salem" },
    { sl: 157, region: "Sivagangai", institution: "Sivagangai CWS", shop: "Municipal Complex, Karaikudi" },
    { sl: 158, region: "Sivagangai", institution: "Sivagangai CWS", shop: "Devakottai" },
    { sl: 159, region: "Sivagangai", institution: "Sivagangai CWS", shop: "Sivagangai" },
    { sl: 160, region: "Tenkasi", institution: "Sankarankovil PCS", shop: "Sankarankovil" },
    { sl: 161, region: "Tenkasi", institution: "Alangulam PACCS", shop: "Alangulam" },
    { sl: 162, region: "Tenkasi", institution: "Tenkasi CWS", shop: "Tenkasi" },
    { sl: 163, region: "Tenkasi", institution: "Sankaran Kovil APCMS", shop: "Tenkasi" },
    { sl: 164, region: "Thanjavur", institution: "Thanjavur CWS", shop: "TCWS Campus, Thanjavur" },
    { sl: 165, region: "Thanjavur", institution: "Pattukottai CMS", shop: "Pattukottai" },
    { sl: 166, region: "Thanjavur", institution: "Chandrasekarapuram CWS", shop: "Sarangapani Keela Veedhi, Kumbakonam" },
    { sl: 167, region: "Thanjavur", institution: "Papanasam CMS", shop: "Papanasam" },
    { sl: 168, region: "Thanjavur", institution: "Madukur PACCS", shop: "Madukur" },
    { sl: 169, region: "Thanjavur", institution: "Thiruvaiyaru PACCS", shop: "Thiruvaiyaru" },
    { sl: 170, region: "Thanjavur", institution: "Eanathi PACCS", shop: "Thanjavur" },
    { sl: 171, region: "Thanjavur", institution: "Thanjavur CWS", shop: "Thanjavur" },
    { sl: 172, region: "Theni", institution: "Theni CMS", shop: "Theni" },
    { sl: 173, region: "Theni", institution: "Uthamapalayam CMS", shop: "Uthamapalayam" },
    { sl: 174, region: "Theni", institution: "Theni CWS", shop: "Paramasivan Koil St, Bodi" },
    { sl: 175, region: "Theni", institution: "Aundipatti PCS", shop: "Aundipatti" },
    { sl: 176, region: "Theni", institution: "Periyakulam PCS", shop: "North Agraharam, Thenkarai, Periyakulam" },
    { sl: 177, region: "Theni", institution: "Kambam Public Servant PCS", shop: "Kambam" },
    { sl: 178, region: "Tirunelveli", institution: "Tirunelveli CWS", shop: "KTC Nagar, VM Chatram" },
    { sl: 179, region: "Tirunelveli", institution: "Tirunelveli CWS", shop: "New Bus Stand" },
    { sl: 180, region: "Tirunelveli", institution: "Nellai PCS", shop: "NGO B colony, Palayamkottai." },
    { sl: 181, region: "Tirunelveli", institution: "Lakshmipathy PCS", shop: "Kallidaikurichi" },
    { sl: 182, region: "Tirunelveli", institution: "Parappadi PACCS", shop: "Parappadi" },
    { sl: 183, region: "Tirunelveli", institution: "Ambasamudram Mini Super Market PCS", shop: "Tirunelveli" },
    { sl: 184, region: "Tirunelveli", institution: "Nanguneri APCMS", shop: "Tirunelveli" },
    { sl: 185, region: "Tirupattur", institution: "Vellore CWS", shop: "Palani Samy Road, Tirupattur" },
    { sl: 186, region: "Tirupattur", institution: "Ambur CMS", shop: "Ambur" },
    { sl: 187, region: "Tirupattur", institution: "Vaniyambadi CMS", shop: "Vaniyambadi" },
    { sl: 188, region: "Tirupattur", institution: "Thirupathur CMS", shop: "North Agraharam Street, Tirupattur" },
    { sl: 189, region: "Tirupattur", institution: "Madappalli PACCS", shop: "Tirupattur" },
    { sl: 190, region: "Tirupattur", institution: "Pachur PACCS", shop: "Tirupattur" },
    { sl: 191, region: "Tiruvallur", institution: "Tiruvallur CWS", shop: "Tiruvallur" },
    { sl: 192, region: "Tiruvallur", institution: "Thiruvallur CWS", shop: "Ponneri" },
    { sl: 193, region: "Tiruvallur", institution: "Saidapet CMS", shop: "Redhills" },
    { sl: 194, region: "Tiruvallur", institution: "Saidapet CMS", shop: "Kalpalayam" },
    { sl: 195, region: "Tiruvallur", institution: "Thiruthani CMS", shop: "Thiruthani" },
    { sl: 196, region: "Tiruvallur", institution: "Cholavarm PACCS", shop: "Tiruvallur" },
    { sl: 197, region: "Tiruvallur", institution: "R.K. Pettai PACCS", shop: "Tiruvallur" },
    { sl: 198, region: "Tiruvannamalai", institution: "Tiruvannamalai CWS (Karpagam)", shop: "Vada Sannathi Street, Tiruvannamalai" },
    { sl: 199, region: "Tiruvannamalai", institution: "Tiruvannamalai CMS", shop: "Vengikkal, Thiruvannamalai" },
    { sl: 200, region: "Tiruvannamalai", institution: "Polur CMS", shop: "Polur" },
    { sl: 201, region: "Tiruvannamalai", institution: "Chengam CMS", shop: "Chengam" },
    { sl: 202, region: "Tiruvannamalai", institution: "Cheyyaru CMS", shop: "Cheyyaru" },
    { sl: 203, region: "Tiruvannamalai", institution: "Vanthavasi CMS", shop: "Vanthavasi" },
    { sl: 204, region: "Tiruvannamalai", institution: "Arani PCS", shop: "Arani" },
]
  return (
    <div className="max-w-6xl mx-auto my-10 px-6">
      {/* Header */}
      <h2 className="text-3xl font-bold text-center text-[#0D3B66] mb-6">
        Kooturavu Marundhagam
      </h2>

      {/* Overview */}
      <h2 className="text-3xl font-bold mb-4 text-gray-900">Overview</h2>
      <div className="bg-[#E8F1FA] border-l-4 border-[#1E90FF] rounded-xl p-6 shadow-md mb-6">
        <p className="text-gray-800 text-lg leading-relaxed">
          Kooturavu Marundhagam is Tamil Nadu’s flagship cooperative initiative to make essential
          medicines and healthcare products affordable and accessible to every citizen. Operating
          through a wide network of cooperative stores, these medical shops ensure uninterrupted
          availability of quality medicines at fair and transparent prices, especially for
          low-income and vulnerable households.
        </p>
      </div>

      {/* Districtwise Section */}
      <div className="mb-6">
        <button
          className="flex items-center gap-2 text-lg font-semibold text-[#0D3B66] hover:text-[#1E90FF]"
          onClick={() => setShowTable(!showTable)}
        >
          <span>{showTable ? "▼" : "►"}</span>
          Districtwise Kooturavu Marundhagam
        </button>

        {showTable && (
          <div className="overflow-x-auto mt-4 border rounded-xl shadow-md">
            <table className="min-w-full bg-white text-left">
              <thead className="bg-[#1E90FF] text-white">
                <tr>
                  <th className="px-4 py-2">Sl. No.</th>
                  <th className="px-4 py-2">Name of the Region</th>
                  <th className="px-4 py-2">Name of the Institutions</th>
                  <th className="px-4 py-2">Name of the Shops</th>
                </tr>
              </thead>
              <tbody>
                {kooturavuData.map((item) => (
                  <tr key={item.sl} className="border-b hover:bg-gray-50">
                    <td className="px-4 py-2">{item.sl}</td>
                    <td className="px-4 py-2">{item.region}</td>
                    <td className="px-4 py-2">{item.institution}</td>
                    <td className="px-4 py-2">{item.shop}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Kooturavu;
